import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQueryWithReauth } from './baseQuery';
import { GetTransactionsParams, TransactionsList } from '../types/transaction';

export const transactionsAPI = createApi({
    reducerPath: 'transactionsAPI',
    baseQuery: axiosBaseQueryWithReauth({
        baseUrl: process.env.REACT_APP_API_URL
    }),
    tagTypes: ['Transaction'],
    endpoints: (builder) => ({
        getAllTransactions: builder.query<TransactionsList, GetTransactionsParams>({
            query: ({ page, pageSize, orderBy, searchTerm, filters, clientId }) => ({
                url: 'Transactions',
                method: 'GET',
                params: {
                    page,
                    pageSize,
                    orderBy,
                    searchTerm,
                    filters: JSON.stringify(filters),
                    clientId
                }
            }),
            providesTags: [{ type: 'Transaction', id: 'LIST' }]
        }),
    }),
});

export const {
    useLazyGetAllTransactionsQuery,
} = transactionsAPI;